/* eslint-disable */
import React, {useState} from 'react';
import 'contents/assets/scss/page/student.scss';
function SchoolManage() {
  return (
    <main className="com_container p_school_manage">
      <div className="com_center_wrap">
        <section className="com_tit_wrap">
          <h2 className="com_pg_tit icon menu1_21">학교명 관리</h2>
          <div className="com_btn_wrap">
            <button className="com_btn orange s btn_plus">학교 등록</button>
          </div>
        </section>
        <section className="com_pg_container">
          <section className="box">
            <div className="com_board_list__top">
              <select className="select">
                <option value="지역 선택">지역 선택</option>
              </select>
              <section className="com_board_search end">
                <article className="search">
                  <input type="search" placeholder="검색할 내용을 입력" className="input s type_search" />
                  <button className="com_btn gray ws s icon_search"></button>
                </article>
              </section>
            </div>
            <table className="com_board_list">
              <colgroup>
                <col width="4%" />
                <col width="30%" />
                <col width="10%" />
                <col width="10%" />
                <col width="10%" />
              </colgroup>
              <thead>
                <tr>
                  <th>No.</th>
                  <th>학교명</th>
                  <th>학교 지역</th>
                  <th>학교 지역 상세</th>
                  <th>학생수</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>11</td>
                  <td>대모초등학교</td>
                  <td>경기도</td>
                  <td>수원시 팔달구</td>
                  <td>290</td>
                </tr>
                {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((i, idx) => {
                  return (
                    <tr key={idx}>
                      <td>{10 - idx}</td>
                      <td>도성초등학교</td>
                      <td>서울</td>
                      <td>강남구</td>
                      <td>200</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </section>
          {/* 상세보기 */}
          <section className="box">
            <div className="detail_tit dot">
              상세보기
              <div className="com_btn_wrap right">
                <button className="btn_edit"></button>
                <button className="btn_delete"></button>
              </div>
            </div>
            <div className="com_input_wrap">
              <div className="input_row">
                <div className="txt">학교 지역 선택</div>
                <select className="select">
                  <option value="지역">지역</option>
                  <option value="지역">지역</option>
                </select>
                <select className="select">
                  <option value="지역 상세 선택">지역 상세 선택</option>
                  <option value="지역 상세 선택">지역 상세 선택</option>
                </select>
              </div>
              <div className="input_row">
                <div className="txt">학교명 입력</div>
                <input type="text" className="input" placeholder="학교명 입력" />
                <button className="com_btn orange xs">등록</button>
              </div>
              <div className="input_row start">
                <div className="txt">내신 기간</div>
                <div className="cont">
                  <div className="com_calendar_wrap">
                    <div className="year ">
                      <button className="btn btn_first"></button>
                      <button className="btn btn_prev"></button>
                      <button className="btn_txt">2023</button>
                      <button className="btn btn_next"></button>
                      <button className="btn btn_last"></button>
                    </div>
                  </div>
                  <ul className="date_list">
                    <li className="com_input_wrap flex_row">
                      <span className="tit">1학년</span>
                      <div className="date_wrap">
                        <input type="date" className="com_datepicker" placeholder="2022. 01. 01" />
                      </div>
                    </li>
                    <li className="com_input_wrap flex_row">
                      <span className="tit">2학년</span>
                      <div className="date_wrap">
                        <input type="date" className="com_datepicker" placeholder="2022. 01. 01" />
                      </div>
                    </li>
                    <li className="com_input_wrap flex_row">
                      <span className="tit">3학년</span>
                      <div className="date_wrap">
                        <input type="date" className="com_datepicker" placeholder="2022. 01. 01" />
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="com_btn_wrap center bottom">
                <button className="com_btn orange s">등록</button>
              </div>
            </div>
            <hr className="com_divider" />
            <div className="tb_tit">
              서울 <span className="dot" />
              은평구 <span className="dot" />
              은평고등학교
            </div>
            <table className="com_board_list">
              <colgroup>
                <col width="10%" />
                <col width="15%" />
                <col width="20%" />
                <col width="15%" />
                <col width="15%" />
              </colgroup>
              <thead>
                <tr>
                  <th>No.</th>
                  <th>학생명 (45)</th>
                  <th>진행수업</th>
                  <th>교사</th>
                  <th>담임</th>
                </tr>
              </thead>
              <tbody>
                {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((i, idx) => {
                  return (
                    <tr key={idx}>
                      <td>{10 - idx}</td>
                      <td>가길동103</td>
                      <td>수학</td>
                      <td>김선생103</td>
                      <td>이선생304</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </section>
        </section>
      </div>
    </main>
  );
}

export default SchoolManage;
